module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "企业名称",
      "icon": "circle-close",
      "on-icon-click": _vm.cleanFilter
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getCompanies
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companies,
      "border": "",
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "name",
      "label": "企业名称",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "city",
      "label": "城市",
      "width": "80",
      "formatter": _vm.formatCity,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "address",
      "label": "企业地址",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "contactName",
      "label": "联系人",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "contactPhone",
      "label": "联系电话",
      "width": "130",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "createdAt",
      "label": "创建时间",
      "formatter": _vm.formatCreateTime,
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业别名",
      "prop": "alias"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.alias),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "alias", $$v)
      },
      expression: "editForm.alias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "cityId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.cityId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cityId", $$v)
      },
      expression: "editForm.cityId"
    }
  }, _vm._l((_vm.cities), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.convertAddress2
    },
    model: {
      value: (_vm.editForm.address),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "address", $$v)
      },
      expression: "editForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "contactName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.contactName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "contactName", $$v)
      },
      expression: "editForm.contactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "contactPhone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.contactPhone),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "contactPhone", $$v)
      },
      expression: "editForm.contactPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业别名",
      "prop": "alias"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.alias),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "alias", $$v)
      },
      expression: "addForm.alias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "cityId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.cityId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "cityId", $$v)
      },
      expression: "addForm.cityId"
    }
  }, _vm._l((_vm.cities), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.convertAddress
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "contactName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.contactName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "contactName", $$v)
      },
      expression: "addForm.contactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "contactPhone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.contactPhone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "contactPhone", $$v)
      },
      expression: "addForm.contactPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.viewVisible) ? _c('el-tabs', [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', [_vm._v("企业用户管理")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleAddUser
    }
  }, [_vm._v("新增用户")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.usersLoading),
      expression: "usersLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "border": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "name",
      "label": "姓名",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "username",
      "label": "用户名",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "email",
      "label": "邮箱",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "电话",
      "prop": "phone",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "createdAt",
      "label": "创建时间",
      "formatter": _vm.formatCreateTime,
      "width": "150",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updatedAt",
      "label": "更新时间",
      "formatter": _vm.formatUpdateTime,
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEditUser(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDelUser(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleTick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("踢出")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', [_vm._v("企业区域管理")])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleAddGroup
    }
  }, [_vm._v("新增区域")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.groupsLoading),
      expression: "groupsLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.groups,
      "border": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "name",
      "label": "区域名称",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "createdAt",
      "label": "创建时间",
      "formatter": _vm.formatCreateTime,
      "width": "150",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updatedAt",
      "label": "更新时间",
      "formatter": _vm.formatUpdateTime,
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEditGroup(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (scope.row.name != '默认区域') ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDelGroup(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增用户",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addUserFormVisible),
      callback: function($$v) {
        _vm.addUserFormVisible = $$v
      },
      expression: "addUserFormVisible"
    }
  }, [_c('el-form', {
    ref: "addUserForm",
    attrs: {
      "model": _vm.addUserForm,
      "label-width": "80px",
      "rules": _vm.addUserFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "username"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addUserForm.username),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "username", $$v)
      },
      expression: "addUserForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.addUserForm.password),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "password", $$v)
      },
      expression: "addUserForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addUserForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "name", $$v)
      },
      expression: "addUserForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addUserForm.email),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "email", $$v)
      },
      expression: "addUserForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addUserForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "phone", $$v)
      },
      expression: "addUserForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addUserFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addUserLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addUserSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑用户",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editUserFormVisible),
      callback: function($$v) {
        _vm.editUserFormVisible = $$v
      },
      expression: "editUserFormVisible"
    }
  }, [_c('el-form', {
    ref: "editUserForm",
    attrs: {
      "model": _vm.editUserForm,
      "label-width": "80px",
      "rules": _vm.editUserFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.editUserForm.username),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "username", $$v)
      },
      expression: "editUserForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.editUserForm.password),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "password", $$v)
      },
      expression: "editUserForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editUserForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "name", $$v)
      },
      expression: "editUserForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editUserForm.email),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "email", $$v)
      },
      expression: "editUserForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editUserForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "phone", $$v)
      },
      expression: "editUserForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editUserFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editUserLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editUserSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增区域",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addGroupFormVisible),
      callback: function($$v) {
        _vm.addGroupFormVisible = $$v
      },
      expression: "addGroupFormVisible"
    }
  }, [_c('el-form', {
    ref: "addGroupForm",
    attrs: {
      "model": _vm.addGroupForm,
      "label-width": "80px",
      "rules": _vm.addGroupFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "区域名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addGroupForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addGroupForm, "name", $$v)
      },
      expression: "addGroupForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addGroupFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addGroupLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addGroupSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑区域",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editGroupFormVisible),
      callback: function($$v) {
        _vm.editGroupFormVisible = $$v
      },
      expression: "editGroupFormVisible"
    }
  }, [_c('el-form', {
    ref: "editGroupForm",
    attrs: {
      "model": _vm.editGroupForm,
      "label-width": "80px",
      "rules": _vm.editGroupFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "区域名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editGroupForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editGroupForm, "name", $$v)
      },
      expression: "editGroupForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editGroupFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editGroupLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editGroupSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3da55fb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/Company.vue
// module id = 1301
// module chunks = 1